// @ts-expect-error incompatibility with node16 resolution
import {Dialog, Transition} from '@headlessui/react';
import clsx from 'clsx';
import {Fragment, useState} from 'react';
import LegalsFooterGroupContent from './LegalsFooterGroupContent.client';
import {LegalsFooter} from '../../../types';

type Props = {
  legals: LegalsFooter;
};

export default function SearchNavGroupDialog({legals}: Props) {
  const [isOpen, setIsOpen] = useState(false)
  const handleClose = () => setIsOpen(false)
  const handleOpen = () => setIsOpen(true)

  return (
    <>
      {isOpen ? (
        <p
          className={clsx(
            'cursor-pointer w-full block link--nav text-right lg:text-left',
            isOpen && 'text-main'
          )}
          onClick={handleClose}
        >
          {legals.title}
        </p>
      ) : (
        <button
          className={clsx(
            'w-full block link--nav text-right lg:text-left',
            isOpen && 'text-main'
          )}
          onClick={handleOpen}
        >
          {legals.title}
        </button>
      )}
      <Transition show={isOpen}>
        <Dialog
          open={isOpen}
          className="relative z-40"
          onClose={handleClose}
          static
        >
          {/* Overlay */}
          <Transition.Child
            as={Fragment}
            // enter="ease-out duration-500"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            // leave="ease-in duration-500"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div
              aria-hidden="true"
              className={clsx(
                'fixed inset-0',
                'layerDialog'
              )}
            />
          </Transition.Child>

          {/* Panel */}
          <Transition.Child
            as={Fragment}
            // enter="ease-in-out duration-500"
            enterFrom="-translate-y-screen"
            enterTo="translate-y-0"
            // leave="ease-in-out duration-500"
            leaveFrom="translate-y-0"
            leaveTo="-translate-y-screen"
          >
            <Dialog.Panel
              className="fixed bottom-0 w-full overflow-y-auto bg-white p-10"
            >
              <LegalsFooterGroupContent
                links={legals.links}
                onClose={handleClose}
              />
            </Dialog.Panel>
          </Transition.Child>
        </Dialog>
      </Transition>
    </>
  );
}
